module.exports = __webpack_public_path__ + "img/seedlingseedling_gray.939b331d.svg";